import {createRouter, createWebHistory} from "vue-router";

import routes from "@/router/routes";

import {checkAccessMiddleware} from "./middlewares/checkAccessMiddleware";

const router = createRouter({
    history: createWebHistory(),
    linkActiveClass: "active",
    linkExactActiveClass: "active",
    routes,
});

router.beforeEach(checkAccessMiddleware);

export default router;
